export default function () {
  this.loadBoardingPlaces();
}
